import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { Body, Button, Card, Heading, I, Stack } from '@leanin/ui';
import { FlowShell } from '@/components/onboarding/FlowShell';
import { trackOnboardingStepCompleted } from '@/lib/analytics/events';
import { flowStepParams } from '@/lib/analytics/onboarding-steps';
import { Picture } from '@/components/media/Picture';
import nlAccessHow from '@/assets/onboarding/nl-access-how.png?w=440;880;1320&format=avif;webp;png&as=picture';
import { NL_ROLE, NL_STEPS } from './-steps';

// Network Leader onboarding tour — step 4 of 6.
// Shows the path a leader takes to reach the Network admin/Manage surface:
// Networks in the sidebar → their Network page → the Manage button.

export const Route = createFileRoute('/onboarding/nl/access-network')({
  component: NLOnboardingAccessNetworkPage,
});

function NLOnboardingAccessNetworkPage() {
  const navigate = useNavigate();
  return (
    <FlowShell
      role={NL_ROLE}
      stepIndex={3}
      steps={NL_STEPS}
      minutes={2}
      title="Access your Network settings to personalize your community’s experience."
      primary={
        <Button
          variant="primary"
          iconRight={I.arrow}
          onClick={() => {
            trackOnboardingStepCompleted(
              flowStepParams('/onboarding/nl/access-network'),
            );
            navigate({ to: '/onboarding/nl/manage-network' });
          }}
        >
          Next
        </Button>
      }
      secondary={
        <Button
          variant="ghost"
          onClick={() => navigate({ to: '/onboarding/nl/network-page' })}
        >
          Back
        </Button>
      }
    >
      <Stack gap="md">
        <Heading level={2}>Access your Network settings</Heading>
        <Body size="md">
          Access your Network settings directly from your Network page to
          update and manage your community.
        </Body>
        <Card pad="flush" clip>
          <Picture
            image={nlAccessHow}
            alt="Three annotated steps: select Networks from the sidebar, open your Network page, click Manage to update settings"
            sizes="(max-width: 720px) 100vw, 880px"
            style={{ width: '100%', height: 'auto', display: 'block' }}
          />
        </Card>
      </Stack>
    </FlowShell>
  );
}
